import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Tuneza Lodge</h3>
            <p className="text-gray-400 mb-4">
              At the heart of Ntchisi, offering luxurious accommodations, conferencing, and dining in a tranquil natural setting.
            </p>
            <div className="flex space-x-4">
              <a href="https://web.facebook.com/p/Tuneza-Lodge-100056730953211/?_rdc=1&_rdr#" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold-500 transition">
                <FaFacebook size={20} />
              </a>
              <a href="https://instagram.com/tunezalodge" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold-500 transition">
                <FaInstagram size={20} />
              </a>
              <a href="https://twitter.com/tunezalodge" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold-500 transition">
                <FaTwitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-400 hover:text-gold-500 transition">Home</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-gold-500 transition">About Us</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-gold-500 transition">Services</a></li>
              <li><a href="#gallery" className="text-gray-400 hover:text-gold-500 transition">Gallery</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-gold-500 transition">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-gray-400">
              <p className="flex items-start">
                <FaMapMarkerAlt className="mr-2 mt-1 flex-shrink-0" />
                <span>Ntchisi, Malawi</span>
              </p>
              <p className="flex items-center">
                <FaPhone className="mr-2" />
                <span>+265 (0) 892 086 0 91</span>
              </p>
              <p className="flex items-center">
                <FaEnvelope className="mr-2" />
                <span>info@tunezalodge.com</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} Tuneza Lodge. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;